module.exports = __webpack_public_path__ + "img/9.d9895a86.jpg";